module.exports = __webpack_public_path__ + "static/img/gpt42.11d30cf3.jpg";